// src/components/Admin/Common/ConfirmationModal.jsx
import React from 'react';
// Basic Modal styling (you might have a global Modal component)
const ModalContainer = ({ isOpen, onClose, title, children, onConfirm }) => {
    if (!isOpen) return null;
    return (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1050 }}>
            <div style={{ background: 'white', padding: '20px', borderRadius: '8px', width: '400px', maxHeight: '90vh', overflowY: 'auto' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
                    <h3>{title || "Confirm Action"}</h3>
                    <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: '1.5rem', cursor: 'pointer' }}>&times;</button>
                </div>
                <div style={{marginBottom: '20px'}}>{children}</div>
                <div style={{display: 'flex', justifyContent: 'flex-end'}}>
                    <button onClick={onClose} style={{marginRight: '10px', padding: '8px 12px', background: '#6c757d', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer'}}>Cancel</button>
                    <button onClick={onConfirm} style={{padding: '8px 12px', background: '#dc3545', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer'}}>Confirm</button>
                </div>
            </div>
        </div>
    );
};
export default ModalContainer;